<script lang="ts">
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"

    export let field: TaskStepField<"textarea">,
        value = "",
        fullPath = "",
        bigOne = false
</script>

<div class="textareaWidget">
    <Input
        placeholder="{field.label}"
        id="{fullPath}-{field.name}"
        type="textarea"
        onChange="{onChange}"
        smallTextarea="{!bigOne}"
        bind:value="{value}"
    />
</div>

<style lang="less">
    .textareaWidget:global {
        width: 100%;
        .textarea {
            min-height: 115px;
        }
    }
</style>
